module.exports = __webpack_public_path__ + "img/4.e47e5af5.svg";